module.exports = __webpack_public_path__ + "static/imgCrearContenido_AR-b6a953a5209c55fa2db63a1ea2ec9f43.webp";